var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleBtnLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "GoogleBtnLogo_svg__[object_Object]b",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "GoogleBtnLogo_svg__[object_Object]c",
    x: 5,
    y: 5,
    width: 38,
    height: 38,
    rx: 1
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "GoogleBtnLogo_svg__[object_Object]a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.168 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.084 0",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 3)",
    filter: "url(#GoogleBtnLogo_svg__[object_Object]a)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#4285F4",
    xlinkHref: "#GoogleBtnLogo_svg__[object_Object]b"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GoogleBtnLogo_svg__[object_Object]b"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GoogleBtnLogo_svg__[object_Object]b"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GoogleBtnLogo_svg__[object_Object]b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#GoogleBtnLogo_svg__[object_Object]c"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GoogleBtnLogo_svg__[object_Object]c"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GoogleBtnLogo_svg__[object_Object]c"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#GoogleBtnLogo_svg__[object_Object]c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.64 23.205c0-.639-.057-1.252-.164-1.841H23v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 32c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711h-3.007v2.332A8.997 8.997 0 0023 32z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.964 24.71a5.41 5.41 0 01-.282-1.71c0-.593.102-1.17.282-1.71v-2.332h-3.007A8.996 8.996 0 0014 23c0 1.452.348 2.827.957 4.042l3.007-2.332z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 17.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C27.463 14.891 25.426 14 23 14a8.997 8.997 0 00-8.043 4.958l3.007 2.332c.708-2.127 2.692-3.71 5.036-3.71z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14h18v18H14V14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleBtnLogo);
export default ForwardRef;